var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHowToRegFilled = function SvgHowToRegFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M7 2.492a4.242 4.242 0 1 1 6 6 4.242 4.242 0 0 1-6-6ZM4.105 12.704c1.627-.947 3.762-1.463 5.895-1.463 1.628 0 3.247.302 4.641.859a.75.75 0 0 1 .122 1.33c-1.26.796-1.776 1.825-1.937 2.786-.167.992.043 1.933.275 2.469a.75.75 0 0 1-.688 1.048H3a1.75 1.75 0 0 1-1.75-1.75v-1c0-1.881 1.234-3.335 2.855-4.279Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m19.222 15.889-2.778 2.778L14.778 17M17 22a5 5 0 0 1-5-5c0-2.704 2.3-5.003 5.004-5A5 5 0 0 1 17 22Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHowToRegFilled);
export default ForwardRef;